import { Routes,BrowserRouter } from 'react-router-dom';
import './App.css';
import Division3 from './components-2/Division3';
import Food1 from './components-2/Food1';
import Others1 from './components-2/Others1';
import Services1 from './components-2/Services1';
import Tophead1 from './components-2/TopHead1';
import Dashboard1 from './components1/Dashboard1';
import Router from './routes';


function App() {
  return (
    // <div className='appki'>
      <>
      <Router />
      </>
    //  {/* </div> */}
  );
}

export default App;
